export const ifMobile = (isMobileView, props) => isMobileView ? (props.mainMobile || props.extraMobile === props.data) : true;